@if (src) {
  <nz-avatar
    [nzSize]="size"
    [nzSrc]="getAsString(src | showUserAvatar | async)"
  ></nz-avatar>
} @else {
  <nz-avatar [nzSize]="size" [nzText]="txt"></nz-avatar>
}
